module.exports = __webpack_public_path__ + "img/mobile.0c56b4ca.svg";